// Editorial product paths chosen after reviewing each complete article.
// Product cards resolve these canonical slugs through the shared catalog.
// Empty productSlugs means a tailored CTA only; absent entries keep news posts concise.
export const blogProductDiscovery = {
  "custom-stain-remover-pens": {
    "eyebrow": "Private label stain treatment",
    "title": "Develop a Stain Remover Pen for Your Brand",
    "description": "Review the pen format, then discuss your target stains, applicator, branding, and sample requirements with Klean Leaf.",
    "href": "/products/stain-removal-pen",
    "buttonText": "Explore Stain Remover Pens",
    "productSlugs": [
      "stain-removal-pen",
      "stain-removal-wipes",
      "stain-removal-spray"
    ]
  },
  "laundry-detergent-sheets-vs-liquid": {
    "title": "Review Laundry Detergent Sheets",
    "description": "Explore the sheet format and discuss formulation and packaging for your brand.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "View Laundry Detergent Sheets",
    "productSlugs": []
  },
  "pva-controversy-klean-leaf-innovation": {
    "title": "Explore PVA-Free Sheet Development",
    "description": "Review the PVA-free product overview and discuss formula requirements, development status, and samples.",
    "href": "/products/pva-free-laundry-detergent-sheets",
    "buttonText": "View PVA-Free Laundry Sheets",
    "productSlugs": []
  },
  "klean-leaf-pva-free-laundry-sheets-are-here": {
    "title": "Compare Laundry Sheet Development Paths",
    "description": "Review the standard and PVA-free sheet pages before discussing your formula and packaging brief.",
    "href": "/products/pva-free-laundry-detergent-sheets",
    "buttonText": "Explore PVA-Free Sheets",
    "productSlugs": [
      "pva-free-laundry-detergent-sheets",
      "laundry-detergent-sheets"
    ]
  },
  "why-refill-shops-love-bulk-unpacked-detergent-sheets": {
    "title": "Plan Your Laundry Sheet Refill Range",
    "description": "Review the laundry sheet format, then discuss bulk packaging, storage, and your refill program with our team.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Sheet Options",
    "productSlugs": []
  },
  "your-premier-partner": {
    "title": "Plan Your Private Label Laundry Sheets",
    "description": "Review laundry sheet formulas, packaging and customization with a manufacturing team focused on your brand.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "View Laundry Detergent Sheets",
    "productSlugs": []
  },
  "do-laundry-detergent-sheets-really-clean-formula-improvements": {
    "title": "Review Enzyme Sheets and Stain Treatment",
    "description": "Compare these product directions when preparing your cleaning-performance and sample brief.",
    "href": "/products/3-in-1-enzyme-laundry-detergent-sheets",
    "buttonText": "Explore Enzyme Laundry Sheets",
    "productSlugs": [
      "3-in-1-enzyme-laundry-detergent-sheets",
      "5-in-1-solid-enzyme-laundry-detergent-sheets",
      "stain-removal-spray"
    ]
  },
  "how-laundry-detergent-sheets-are-made-country-origin-transparency": {
    "title": "Plan Your Laundry Sheet Manufacturing Brief",
    "description": "Review these laundry sheet options and confirm the formulation, packaging, and supporting product information for your project.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Review Laundry Detergent Sheets",
    "productSlugs": [
      "laundry-detergent-sheets",
      "baby-laundry-detergent-sheets-for-sensitive-skin"
    ]
  },
  "how-to-start-private-label-laundry-detergent-sheets-brand": {
    "title": "Compare Products for Your First Laundry Sheet Line",
    "description": "Use these formula directions to prepare a focused sample request; confirm suitability and specifications with our team.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Review Laundry Sheet Options",
    "productSlugs": [
      "3-in-1-enzyme-laundry-detergent-sheets",
      "baby-laundry-detergent-sheets-for-sensitive-skin",
      "pva-free-laundry-detergent-sheets"
    ]
  },
  "launch-laundry-detergent-sheets-product-line-klean-leaf": {
    "title": "Review the Product Before Your First Inquiry",
    "description": "Explore laundry detergent sheets and note the formula, scent, and packaging details you want to discuss.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Detergent Sheets",
    "productSlugs": []
  },
  "custom-fragrance-laundry-detergent-sheets": {
    "title": "Build Your Laundry Sheet Fragrance Brief",
    "description": "Review the laundry detergent sheet format alongside your scent reference, pack count, and sampling plan.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Sheet Customization",
    "productSlugs": []
  },
  "long-lasting-fragrance-laundry-detergent-sheets": {
    "title": "Plan a Scented Laundry Sheet Project",
    "description": "Review the laundry sheet format, then discuss your fragrance target and finished-sample evaluation with our team.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "View Laundry Sheet Fragrance Options",
    "productSlugs": []
  },
  "laundry-detergent-sheets-smart-business-opportunity": {
    "title": "Choose a Laundry Sheet Direction for Your Brand",
    "description": "Compare the core sheet format with a baby or sensitive-skin project brief; confirm suitability and formula requirements before launch.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Sheet Options",
    "productSlugs": [
      "laundry-detergent-sheets",
      "baby-laundry-detergent-sheets-for-sensitive-skin"
    ]
  },
  "rise-of-detergent-sheets": {
    "title": "Match Laundry Sheets to Your Sales Channel",
    "description": "Compare formula and packaging directions before requesting representative samples.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Review Laundry Detergent Sheets",
    "productSlugs": [
      "laundry-detergent-sheets",
      "3-in-1-enzyme-laundry-detergent-sheets",
      "laundry-detergent-sheets-vending-machine-pack"
    ]
  },
  "laundry-detergent-sheets-packaging-label-requirements": {
    "title": "Confirm the Product Before Preparing Artwork",
    "description": "Review the laundry sheet format and discuss the final formula, sheet count, and package configuration for your project.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "View Laundry Sheet Packaging",
    "productSlugs": []
  },
  "private-label-laundry-detergent-sheets-packaging-process": {
    "title": "Review Laundry Sheet Packaging Directions",
    "description": "Compare the standard sheet product with a vending-pack project before choosing your package dimensions and artwork.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Sheet Packaging",
    "productSlugs": [
      "laundry-detergent-sheets",
      "laundry-detergent-sheets-vending-machine-pack"
    ]
  },
  "year-of-innovation-in-laundry-care": {
    "title": "Explore Today’s Laundry Sheet Options",
    "description": "Use the current product pages to review formula and packaging directions for your next sample brief.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Review Laundry Detergent Sheets",
    "productSlugs": [
      "laundry-detergent-sheets",
      "3-in-1-enzyme-laundry-detergent-sheets"
    ]
  },
  "are-aluminum-bottles-more-eco-friendly-than-plastic": {
    "title": "Review Laundry Sheet Formula and Packaging Options",
    "description": "Compare standard and PVA-free sheet directions while evaluating the full product and packaging brief.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "Explore Laundry Detergent Sheets",
    "productSlugs": [
      "laundry-detergent-sheets",
      "pva-free-laundry-detergent-sheets"
    ]
  },
  "best-laundry-detergent-sheet-manufacturers-2026": {
    "title": "Review Klean Leaf’s Laundry Sheet Products",
    "description": "Compare these product directions before requesting a formula-specific sample and quotation.",
    "href": "/products/laundry-detergent-sheets",
    "buttonText": "View Laundry Sheet MOQ & Specifications",
    "productSlugs": [
      "laundry-detergent-sheets",
      "3-in-1-enzyme-laundry-detergent-sheets",
      "pva-free-laundry-detergent-sheets"
    ]
  },
  "what-else-klean-leaf-manufactures": {
    "eyebrow": "Beyond laundry sheets",
    "title": "Build Beyond Your Laundry Sheet Line",
    "description": "Laundry sheets are our core expertise. Explore the wider catalog and the specialty tablet formats discussed in this article.",
    "href": "/products",
    "buttonText": "Explore the Cleaning Product Range",
    "productSlugs": [
      "hand-soap-tablets",
      "toilet-bowl-cleaner-tablets",
      "coffee-machine-cleaning-tablets",
      "baby-nursing-bottle-cleaning-tablets"
    ]
  }
};
